/*! modernizr 3.2.0 (Custom Build) | MIT *
 * http://modernizr.com/download/?-prefixed !*/
!function(e,n,t){function r(e,n){return typeof e===n}function o(){var e,n,t,o,i,s,a;for(var f in g)if(g.hasOwnProperty(f)){if(e=[],n=g[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),y.push((o?"":"no-")+a.join("-"))}}function i(e){var n=_.className,t=Modernizr._config.classPrefix||"";if(w&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),w?_.className.baseVal=n:_.className=n)}function s(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function a(e,n){return!!~(""+e).indexOf(n)}function f(e,n){return function(){return e.apply(n,arguments)}}function l(e,n,t){var o;for(var i in e)if(e[i]in n)return t===!1?e[i]:(o=n[e[i]],r(o,"function")?f(o,t||n):o);return!1}function u(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):w?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function p(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function d(){var e=n.body;return e||(e=u(w?"svg":"body"),e.fake=!0),e}function c(e,t,r,o){var i,s,a,f,l="modernizr",p=u("div"),c=d();if(parseInt(r,10))for(;r--;)a=u("div"),a.id=o?o[r]:l+(r+1),p.appendChild(a);return i=u("style"),i.type="text/css",i.id="s"+l,(c.fake?c:p).appendChild(i),c.appendChild(p),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(n.createTextNode(e)),p.id=l,c.fake&&(c.style.background="",c.style.overflow="hidden",f=_.style.overflow,_.style.overflow="hidden",_.appendChild(c)),s=t(p,e),c.fake?(c.parentNode.removeChild(c),_.style.overflow=f,_.offsetHeight):p.parentNode.removeChild(p),!!s}function m(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(p(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+p(n[o])+":"+r+")");return i=i.join(" or "),c("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return t}function v(e,n,o,i){function f(){p&&(delete N.style,delete N.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var l=m(e,o);if(!r(l,"undefined"))return l}for(var p,d,c,v,h,y=["modernizr","tspan"];!N.style;)p=!0,N.modElem=u(y.shift()),N.style=N.modElem.style;for(c=e.length,d=0;c>d;d++)if(v=e[d],h=N.style[v],a(v,"-")&&(v=s(v)),N.style[v]!==t){if(i||r(o,"undefined"))return f(),"pfx"==n?v:!0;try{N.style[v]=o}catch(g){}if(N.style[v]!=h)return f(),"pfx"==n?v:!0}return f(),!1}function h(e,n,t,o,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+S.join(s+" ")+s).split(" ");return r(n,"string")||r(n,"undefined")?v(a,n,o,i):(a=(e+" "+E.join(s+" ")+s).split(" "),l(a,n,t))}var y=[],g=[],C={_version:"3.2.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){g.push({name:e,fn:n,options:t})},addAsyncTest:function(e){g.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var _=n.documentElement,w="svg"===_.nodeName.toLowerCase(),x="Moz O ms Webkit",S=C._config.usePrefixes?x.split(" "):[];C._cssomPrefixes=S;var b=function(n){var r,o=prefixes.length,i=e.CSSRule;if("undefined"==typeof i)return t;if(!n)return!1;if(n=n.replace(/^@/,""),r=n.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+n;for(var s=0;o>s;s++){var a=prefixes[s],f=a.toUpperCase()+"_"+r;if(f in i)return"@-"+a.toLowerCase()+"-"+n}return!1};C.atRule=b;var E=C._config.usePrefixes?x.toLowerCase().split(" "):[];C._domPrefixes=E;var z={elem:u("modernizr")};Modernizr._q.push(function(){delete z.elem});var N={style:z.elem.style};Modernizr._q.unshift(function(){delete N.style}),C.testAllProps=h;C.prefixed=function(e,n,t){return 0===e.indexOf("@")?b(e):(-1!=e.indexOf("-")&&(e=s(e)),n?h(e,n,t):h(e,"pfx"))};o(),i(y),delete C.addTest,delete C.addAsyncTest;for(var P=0;P<Modernizr._q.length;P++)Modernizr._q[P]();e.Modernizr=Modernizr}(window,document);


jQuery(document).ready(function($){

  /* Header search form visibility */
  $('header .toolbar .search').on('click', function(e) {
    const searchInput = $('header .toolbar .search .search_box');

    if (searchInput.val() && !searchInput.hasClass('search_box--focus')) {
      e.preventDefault();
    }

    searchInput.addClass('search_box--focus');

    if (!searchInput.val()) {
      e.preventDefault();
      searchInput.focus();
    }
  });

  if(jQuery.QueryString.success || jQuery.QueryString.entryPoint) {
    $('.form-success.hidden').removeClass('hidden');
  }
  
  if(jQuery.QueryString.test) {
    $('.shuttershop-form:not(.testing)').addClass('hidden');
  }
  
  $('#WebToLeadForm').on('submit', function() {
    var $this = $(this);
    if(typeof ga !== 'undefined') {
    	ga('send', 'event', $this.data('ga-event-category'), $this.data('ga-event-action'), $this.data('ga-event-label'));
    }
  });
  
  $('select[name="how_did_you_hear_about_us_c"]').on('change', function () {
    var $otherField = $('.field-how_did_you_hear_about_us_o_c');
    if($(this).val() == 'Other') { 
      $otherField.removeClass('hidden');
    } else {
      $otherField.addClass('hidden');
    }
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product .thumbs a').on('click', function(e) {
	e.preventDefault();
	switchImage($(this).attr('href'), null, $('.featured img')[0]);
  } );

  $("#menu-toggle").on("click", function() {
		$(".flyout").slideToggle( "fast" );
  });

  $(".more").on("click", function() {
			$(this).nextAll("ul").slideToggle( "fast" );
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
	$(this).blur();
  })

  $("li.dropdown").hover(function(){
			$(this).children('.dropdown').show();
			$(this).children('.dropdown').stop();
			$(this).children('.dropdown').animate({
			  opacity: 1.0
			}, 200);
  }, function(){
			$(this).children('.dropdown').stop();
			$(this).children('.dropdown').animate({
			  opacity: 0.0
			}, 400, function(){
			  $(this).hide();
			});
  });

  // Wrap iframes in div with responsive class
  $(".blocks-wrapper iframe").each(function() {
    $(this).wrap("<div class='responsive-iframe'></div>");
  });

  // Achievements banner slider
  new Swiper('.achievement-banner .swiper', {
    slidesPerView: 1,
    direction: 'horizontal',
    autoplay: {
      delay: 5000,
    },
    loop: true,
    breakpoints: {
      880: {
        slidesPerView: 2
      }
    }
  });

  // News Block Slider
  new Swiper('.block-news__posts.swiper', {
    slidesPerView: 1.2,
    direction: 'horizontal',
    spaceBetween: 40,
    breakpoints: {
      620: {
        slidesPerView: 2.2
      },
      992: {
        slidesPerView: 2.5
      },
      1275: {
        slidesPerView: 3.3
      },
      1400: {
        slidesPerView: 3.5
      }
    }
  });

  const swiperArgs = {
    slidesPerView: 1.2,
    direction: 'horizontal',
    spaceBetween: 40,
    breakpoints: {
      420: {
        slidesPerView: 1.3
      },
      620: {
        slidesPerView: 2.2
      },
      992: {
        slidesPerView: 2.5
      },
      1275: {
        slidesPerView: 3
      }
    },
    on: {
      init: function (swiper) {
        if(swiper.slides.length > 3) {
          swiper.params.breakpoints[1275].slidesPerView = 3.5;
          swiper.currentBreakpoint = false;
          swiper.update()
        }
      }
    }
  }

		// Testimonials Block Slider
		new Swiper('.block-testimonials .swiper', swiperArgs);

    // Videos Block Slider
    const videoSwiperArgs = swiperArgs;
    videoSwiperArgs.on = {
      init: function (swiper) {
        if(swiper.slides.length > 3) {
          swiper.params.breakpoints[1275].slidesPerView = 2.5;
          swiper.currentBreakpoint = false;
          swiper.update()
        }
      }
    }
		new Swiper('.block-videos .swiper', videoSwiperArgs);

		// Card Grid Swipers
    const cardGrid3UpBreakpoint = 991;
    const cardGrid4UpBreakpoint = 1275;

		const cloneCardGridForSwiper = () => {
        let windowWidth = document.documentElement.clientWidth;

		    $(".block-card-grid:not([data-init])").each(function() {
		        const $this = $(this);

		        const gridClass = 'block-card-grid';
		        const swiperClass = `${gridClass}-swiper`;
						const gridClassItem = `${gridClass}__item`;
						const swiperClassItem = `${swiperClass}__item`;
            const gridMarketingItem = `.${gridClassItem}--marketing-item`
            const gridMarketingItems = $(this).find(gridMarketingItem);
            let columns;

            // Don't create a slider under these conditions
		        if(
                $this.hasClass(`${gridClass}--2-up`) ||
                ($this.hasClass(`${gridClass}--3-up`) && windowWidth > cardGrid3UpBreakpoint) ||
                ($this.hasClass(`${gridClass}--4-up`) && windowWidth > cardGrid4UpBreakpoint)
            ) {
		            return;
		        } else if($this.hasClass(`${gridClass}--3-up`) && gridMarketingItems.length > 0 && $(this).children().length === 3) {
			          // add data-init attribute of false, so we avoid creating a slider for a grid of 3 with marketing items
								$this.attr('data-init', false);

								return;
            }

            if(windowWidth <= cardGrid3UpBreakpoint && $this.hasClass(`${gridClass}--3-up`)) {
                columns = 3;
            }

            if(windowWidth <= cardGrid4UpBreakpoint && $this.hasClass(`${gridClass}--4-up`)) {
                columns = 4;
            }

            if (columns) {
		            $this.attr('data-init', true);

				        // Clone card grid
				        const clone = $this.clone().insertAfter($this);

				        // Replace classes
				        if(columns === 3) {
				            clone.addClass(`${swiperClass} ${swiperClass}--3-up`).removeClass(`${gridClass} ${gridClass}--3-up`);
				        } else {
				            clone.addClass(`${swiperClass} ${swiperClass}--4-up`).removeClass(`${gridClass} ${gridClass}--4-up`);
				        }

				        // Find children and replace classes
				        const cloneChildren = clone.find(`.${gridClassItem}`);

				        $(cloneChildren).each(function() {
				            $(this).addClass(`${swiperClassItem} swiper-slide`).removeClass(gridClassItem);
				            $(this).find(`.${gridClassItem}-image`).addClass(`${swiperClassItem}-image`).removeClass(`${gridClassItem}-image`);
				            $(this).find(`.${gridClassItem}-title`).addClass(`${swiperClassItem}-title`).removeClass(`${gridClassItem}-title`);
				            $(this).find(`.${gridClassItem}-body`).addClass(`${swiperClassItem}-body`).removeClass(`${gridClassItem}-body`);
				        });

                // Remove marketing items from clone
                const gridMarketingItemElements = clone.find(gridMarketingItem);

								$(gridMarketingItemElements).each(function() {
                  $(this).remove();
								});

				        // Wrap children with swiper classes
				        clone.find(`.${swiperClassItem}`).wrapAll('<div class="swiper-wrapper"></div>');
				        clone.find(`.swiper-wrapper`).wrap('<div class="swiper"></div>');

				        // Initialise swiper
						    let swiperArgs = {
				            slidesPerView: 1.2,
				            direction: 'horizontal',
				            spaceBetween: 40,
				            breakpoints: {
				                800: {
				                    slidesPerView: 2.4
				                }
				            }
						    }

		            new Swiper(`.${swiperClass}.${swiperClass}--${columns}-up .swiper`, swiperArgs);
            }
		    });
    }

    $(window).resize(function(){
        cloneCardGridForSwiper();
    });

    cloneCardGridForSwiper();

}); // end document ready

// ----------
// Namespace definitions
// ----------
var shuttershop = shuttershop || {};
shuttershop.global = shuttershop.global || {};

//----------
// Master init
//----------
var $window;
shuttershop.init = function() {
	$window = $(window);
  	if($("body.template-index").length) {
  		shuttershop.home();
  	}
};

shuttershop.home = function() {
	var adjustTestimonialsContainer = function() {
		var $homeTestimonialsContainer = $(".home-section-testimonials .testimonial-container"),
	    	maxTestimonailSize = _.max($homeTestimonialsContainer.find(".testimonial").map(function() { return $(this).outerHeight() }));
		$homeTestimonialsContainer.height(maxTestimonailSize);
	}
	adjustTestimonialsContainer();

	$window.on('resize', _l.throttle(adjustTestimonialsContainer, 100));
}

shuttershop.orderColours = function(container, selector, order, cb) {
	var $container = $(container),
		$toOrder = $container.find(selector);
	$toOrder.each(function() {
		var $this = $(this),
			colourName = $this.data('colour-name');
		if(_l.contains(order, colourName)) {
			$this.data("colour-order", _l.indexOf(order, colourName));
		} else {
			$this.data("colour-order", $toOrder.length + 1);
		}
	});
	$toOrder.detach().sort(function(a, b) {
		return $(a).data("colour-order") > $(b).data("colour-order") ? 1 : -1;
	}).appendTo($container);
	if(cb) cb();
}

//----------
// Boot up
//----------
$(document).ready(function() {
	shuttershop.init();
});

//----------
// FAQs
//----------
let acc = document.getElementsByClassName("faq-content__title");
let i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    let panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
